import { render } from "./Reset.vue?vue&type=template&id=532aa01c"
import script from "./Reset.vue?vue&type=script&lang=js"
export * from "./Reset.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/tend_preselect.konnektor.nl_main/node_modules/.pnpm/vue-loader@16.8.3_czxhl45dan3d4o5uu7vih6mmde/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__